import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StreamsConfig } from '../streams.config';
import { PaymentStreamSetting } from '../../models/payment-stream-setting.model';
import { Observable } from 'rxjs';

@Injectable()
export class StreamsService {
  constructor (private httpClient: HttpClient) {}

  getStreams () {
    return this.httpClient.get<PaymentStreamSetting[]>(StreamsConfig.StreamsApi);
  }
}
